import { Divider, Flex, Tabs, Button } from "antd";
import RateioRelatorioCentroCustoComponente from "../Financeiro/Titulo/Rateio/RateioRelatorioCentroCustoComponente";
import TituloScreen from "../Financeiro/Titulo/TituloScreen";
import { Route, Routes, RouterProvider, Navigate } from "react-router-dom";
import TypeViagem from "../../../Models/Domain/Viagem/Viagem";
import { EnumOrigemTipo } from "../../../Models/Financeiro/Titulo/Origem/OrigemTipo";
import { EnumPessoaTipo } from "../../../Models/Pessoa/Pessoa";
import Titulo from "../../../Models/Financeiro/Titulo/Titulo";
import CorrecaoContabilFormBasic from "./Financeiro/CorrecaoContabil/CorrecaoContabilFormBasic";
import CorrecaoContabilFormModal from "./Financeiro/CorrecaoContabil/CorrecaoContabilFormModal";
import { CorrecaoContabil } from "../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import { PlusCircleOutlined } from "@ant-design/icons";
import CorrecaoContabilTablePorViagem from "./Financeiro/CorrecaoContabil/CorrecaoContabilTablePorViagem";
import ComponentePermissao, { usePermitido } from "../../Base/Permissao/ComponentePermissao";
import ViagemFechamentoInfo from "./ViagemFechada/ViagemFechamentoInfo";
import ViagemFechamentoContasTable from "./ViagemFechada/ViagemFechamentoContasTable";
import VaigemFechadaFormModal from "./ViagemFechada/ViagemFechadaFormModal";
import { ViagemFechada } from "../../../Models/Domain/Viagem/ViagemFecahmento";
import { useRef } from "react";
import ComponentePrint, { IComponentePrintRef } from "../../Base/Baixar/ComponentePrint";
import Permissoes from "@/Constants/Permissoes";
import { ReciboDaViagemScreen } from "./Recibos/RecibosDaViagemScreen";
import { useRequerPermissoes } from "@/Hooks/useRequerPermissoes";

export interface IViagemFechamentoScreenProps {
    viagem : TypeViagem;
}
export default function ViagemFechamentoScreen({
    viagem
}:IViagemFechamentoScreenProps) {

    const {
        permitido : permitidoViagemFinanceiroCorrecaoContabilListarListarDaViagem
    } = usePermitido({
        permissoes : ["ViagemFinanceiroCorrecaoContabilListarListarDaViagem"]
    });

    const requerPermissoes = useRequerPermissoes();

    const refPrint = useRef<IComponentePrintRef|null>(null);

    return (
        <Tabs
            destroyInactiveTabPane={true}
            items={[
                {
                    key: "ReceitaXDespesas",
                    label: "Receita x Despesas",
                    children: <RateioRelatorioCentroCustoComponente codCentroCusto={viagem.centroDeCusto!.codigo!} />,
                },
                {
                    key: "receber",
                    label: "A Receber",
                    children: (
                        <TituloScreen
                            consultaScreenProps={{
                                receita : true,
                                exibirCamposFiltro: true,
                                exibirCampoOrigem: false,
                                defaultFilters: {
                                    ativo: undefined,
                                    titulo: {
                                        origem: {
                                            codTipo: EnumOrigemTipo.Viagem,
                                            codReferencia: viagem.codigo,
                                        },
                                    } as Titulo<any>,
                                },
                            }}
                            formCadastroProps={{
                                aReceberProps: {
                                    defaultValues: {
                                        origem: {
                                            codTipo: EnumOrigemTipo.Viagem ?? 0,
                                            codReferencia: viagem.codigo,
                                        },
                                        beneficiario: {
                                            tipo: EnumPessoaTipo.EMPRESA,
                                        },
                                        codBeneficiario: viagem.centroDeCusto?.codEmpresa,
                                        rateios: [
                                            {
                                                centroCusto: viagem.centroDeCusto,
                                            },
                                        ],
                                    } as Titulo<any>,
                                    disable: {
                                        titulo: {
                                            origem: { codReferencia: true },
                                            codBeneficiario: true,
                                            rateios: {
                                                codCentroCusto: true,
                                                codPlanoConta: false,
                                            },
                                        },
                                    },
                                },
                                aPagarProps: {
                                    defaultValues: {
                                        origem: {
                                            codTipo: EnumOrigemTipo.Viagem,
                                            codReferencia: viagem.codigo,
                                        },
                                        devedor: {
                                            tipo: EnumPessoaTipo.EMPRESA,
                                        },
                                        codDevedor: viagem.centroDeCusto?.codEmpresa,
                                        rateios: [
                                            {
                                                centroCusto: viagem.centroDeCusto,
                                            },
                                        ],
                                    } as Titulo<any>,
                                    disable: {
                                        titulo: {
                                            origem: { codReferencia: true },
                                            codDevedor: true,
                                            rateios: {
                                                codCentroCusto: true,
                                                codPlanoConta: false,
                                            },
                                        },
                                    },
                                },
                            }}
                        />
                    ),
                },
                {
                    key: "pagar",
                    label: "A pagar",
                    children: (
                        <TituloScreen
                            consultaScreenProps={{
                                receita : false,
                                exibirCamposFiltro: true,
                                exibirCampoOrigem: false,
                                defaultFilters: {
                                    ativo: undefined,
                                    titulo: {
                                        origem: {
                                            codTipo: EnumOrigemTipo.Viagem,
                                            codReferencia: viagem.codigo,
                                        },
                                    } as Titulo<any>,
                                },
                            }}
                            formCadastroProps={{
                                aReceberProps: {
                                    defaultValues: {
                                        origem: {
                                            codTipo: EnumOrigemTipo.Viagem ?? 0,
                                            codReferencia: viagem.codigo,
                                        },
                                        beneficiario: {
                                            tipo: EnumPessoaTipo.EMPRESA,
                                        },
                                        codBeneficiario: viagem.centroDeCusto?.codEmpresa,
                                        rateios: [
                                            {
                                                centroCusto: viagem.centroDeCusto,
                                            },
                                        ],
                                    } as Titulo<any>,
                                    disable: {
                                        titulo: {
                                            origem: { codReferencia: true },
                                            codBeneficiario: true,
                                            rateios: {
                                                codCentroCusto: true,
                                                codPlanoConta: false,
                                            },
                                        },
                                    },
                                },
                                aPagarProps: {
                                    defaultValues: {
                                        origem: {
                                            codTipo: EnumOrigemTipo.Viagem,
                                            codReferencia: viagem.codigo,
                                        },
                                        devedor: {
                                            tipo: EnumPessoaTipo.EMPRESA,
                                        },
                                        codDevedor: viagem.centroDeCusto?.codEmpresa,
                                        rateios: [
                                            {
                                                centroCusto: viagem.centroDeCusto,
                                            },
                                        ],
                                    } as Titulo<any>,
                                    disable: {
                                        titulo: {
                                            origem: { codReferencia: true },
                                            codDevedor: true,
                                            rateios: {
                                                codCentroCusto: true,
                                                codPlanoConta: false,
                                            },
                                        },
                                    },
                                },
                            }}
                        />
                    ),
                },
                permitidoViagemFinanceiroCorrecaoContabilListarListarDaViagem && {
                    key: "AjustesContábeis",
                    label: "Ajustes contábeis",
                    children: (
                        <>
                            <Flex justify="end">
                                <ComponentePermissao permissoes={["ViagemFinanceiroCorrecaoContabilInserir"]}>
                                    <CorrecaoContabilFormModal
                                        destroyOnClose={false}
                                        correcaoContabil={
                                            {
                                                codViagem: viagem.codigo ?? 0,
                                            } as CorrecaoContabil
                                        }
                                        textButtonOpen="Novo ajuste contábil"
                                        propsButtonOpen={{
                                            type: "dashed",
                                            icon: <PlusCircleOutlined />,
                                        }}
                                    />
                                </ComponentePermissao>
                            </Flex>
                            <Divider>Ajustes contábeis</Divider>
                            <ComponentePermissao permissoes={["ViagemFinanceiroCorrecaoContabilListarListarDaViagem"]}>
                                <CorrecaoContabilTablePorViagem viagem={viagem} />
                            </ComponentePermissao>
                        </>
                    ),
                },
                permitidoViagemFinanceiroCorrecaoContabilListarListarDaViagem && {
                    key: "Fechamento",
                    label: "Fechamento",
                    children: (
                        <>
                            <VaigemFechadaFormModal
                                initialValues={{
                                    viagemFechada : {
                                        viagem: viagem,
                                        codViagem: viagem.codigo ?? 0,
                                    } as ViagemFechada,
                                    atualizarNota : true                               
                                }}
                            />{" "}
                            <Button type="dashed" onClick={() => refPrint.current?.imprimir()}>
                                Exportar
                            </Button>
                            <Divider></Divider>
                            <ComponentePrint ref={refPrint}>
                                <>
                                    <ViagemFechamentoInfo viagem={viagem} title={null} />
                                    <Divider></Divider>
                                    <ViagemFechamentoContasTable viagem={viagem} />
                                </>
                            </ComponentePrint>
                        </>
                    ),
                },
                requerPermissoes?.alguma(Permissoes.FinanceiroTituloListar) && {
                    key: "faturas",
                    label: "Faturas",
                    children: <ReciboDaViagemScreen viagem={viagem} />,
                },
            ].filter((f) => f !== false)}
        />
    );
}